import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { UiFormModule } from "../../../shared/ui/ui-form.module";
import { MatInputModule } from '@angular/material/input';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatButtonModule } from '@angular/material/button';
import { MatTableModule } from '@angular/material/table';
import { MatIconModule } from '@angular/material/icon';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatCardModule } from '@angular/material/card';
import { MatDividerModule } from '@angular/material/divider';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatSelectModule } from '@angular/material/select';
import { MatDialogModule } from '@angular/material/dialog';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatOptionModule } from '@angular/material/core';
import { RouterModule } from "@angular/router";
import { DragDropModule } from "@angular/cdk/drag-drop";

import { DebitCardListV2Component } from "./components/debit-card-list/debit-card-list.components";
import { CreditCardListV2Component } from "./components/credit-card-list/credit-card-list.components";
import { CreditCardDetailComponent } from "./components/credit-card-detail/credit-card-detail.component";
import { PaymentCardFormDialogComponent } from "./components/payment-card-form-dialog/payment-card-form-dialog.component";
import { SharedModule } from "../../shared/shared.module";

@NgModule({
  declarations: [
    DebitCardListV2Component,
    CreditCardListV2Component,
    CreditCardDetailComponent,
    PaymentCardFormDialogComponent,
  ],
  exports: [
    DebitCardListV2Component,
    CreditCardListV2Component,
  ],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    UiFormModule,
    SharedModule,
    RouterModule,
    FormsModule,

    MatInputModule,
    MatFormFieldModule,
    MatButtonModule,
    MatTableModule,
    MatIconModule,
    MatProgressSpinnerModule,
    MatToolbarModule,
    MatCardModule,
    MatDividerModule,
    MatSelectModule,
    MatAutocompleteModule,
    MatDialogModule,
    MatSnackBarModule,
    MatOptionModule,
    MatDatepickerModule,

    DragDropModule,
  ],
})
export class PaymentCardV2Module { }
